import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, Subject, throwError } from 'rxjs';
import { ErrorsService } from './errors.service';

@Injectable()
export class NotFoundInterceptor implements HttpInterceptor {
  constructor(private errorsService: ErrorsService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (
            error.status === 404 &&
            request.url.indexOf('translate-path') > -1
          ) {
            this.errorsService.notFoundError$.next(request.url);
          } else if (error.status === 503) {
            this.errorsService.maintenanceError$.next(request.url);
          }
        }
        return throwError(error);
      })
    );
  }
}
